import { useState } from 'react';
import { NoSSR, useI18n, useUserInfo } from '@spot-fe/base-ui';
import { gt, safeToFormat1 as safeToFormat } from '@/utils/number';
import { useIsMobile } from '@/hooks/useIsMobile';
import { PrizeType, TaskType, OnGoingProject, TaskStatus } from '@/apis';

export const useText = (task: OnGoingProject) => {
  const { t } = useI18n();
  const { isLogin } = useUserInfo();
  const { isMobile } = useIsMobile();

  const getNameText = () => {
    const taskType = task.taskType;
    const prizeType = task.prizeType;
    const token = task.tokenList?.join('/');

    const nameTextMap: Record<TaskType, string> = {
      [TaskType.All]: t('depositTradeTokenToEarn', { token }),
      [TaskType.Trade]: t('tradeTokenToEarn', { token }),
      [TaskType.Deposit]: t('depositTokenToEarn', { token }),
    };

    const userTextMap: Record<PrizeType, string> = {
      [PrizeType.New]: `${t('newUsersOnly')}`,
      [PrizeType.Old]: `${t('existingUsersOnly')}`,
      [PrizeType.All]: '',
    };

    const userTag = taskType === TaskType.Deposit ? userTextMap[prizeType] : '';

    return {
      title: nameTextMap[taskType],
      tag: userTag,
    };
  };

  const getActionText = () => {
    if (!isLogin) {
      return {
        btn: t('joinNow'),
        tip: null,
      };
    }
    if (task.isJoin === 0) {
      return {
        btn: t('joinNow'),
        tip: t('notRegistered'),
      };
    }
    if (task.isJoin === 1 && task.taskStatus === TaskStatus.Ongoing) {
      return {
        btn: t('completeNow'),
        tip: t('statusNotComplete'),
      };
    }
    return {
      btn: t('checkDetails'),
      tip: t('statusComplete'),
    };
  };

  const getShareText = () => {
    if (gt(task.prizePool, 0) && task.awardToken) {
      return {
        tip: isMobile
          ? t('referAndEarn1', {
              prizepool: `<b>${safeToFormat(task.prizePool, 4)}</b>`,
              token: `<b>${task.awardToken}</b>`,
            })
          : t('shareAndEarn', {
              prizepool: `<b>${safeToFormat(task.prizePool, 4)}</b>`,
              token: `<b>${task.awardToken}</b>`,
            }),
        action: t('shareToEarn1'),
        hasReferral: true,
      };
    }
    return {
      tip: isMobile ? t('referAndEarnShort') : t('referFriendsAndEarn'),
      action: t('shareToEarn1'),
    };
  };

  return {
    getNameText,
    getActionText,
    getShareText,
  };
};
